import { render, staticRenderFns } from "./VideoAnimate.vue?vue&type=template&id=950ab016&scoped=true"
import script from "./VideoAnimate.vue?vue&type=script&lang=js"
export * from "./VideoAnimate.vue?vue&type=script&lang=js"
import style0 from "./VideoAnimate.vue?vue&type=style&index=0&id=950ab016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950ab016",
  null
  
)

export default component.exports